/* B-JMC™ — remplace le texte du logo de l'en-tête par un médaillon 3D qui tourne */
(function () {
  var LAYERS = 12;

  function beads() {
    var out = '';
    for (var k = 0; k < 24; k++) {
      out += "<circle cx='100' cy='18' r='5' fill='currentColor' transform='rotate(" + (k * 15) + " 100 100)'/>";
    }
    return out;
  }

  function layer(i) {
    var z = ((i - LAYERS / 2) * 1.0).toFixed(1);
    var b = (i === LAYERS - 1) ? 1.45 : (0.5 + i * 0.045).toFixed(3);
    return "<svg class='bjmc3d-layer' viewBox='0 0 200 200' style='transform:translateZ(" + z + "px);filter:brightness(" + b + ")'>" +
      "<circle cx='100' cy='100' r='96' fill='none' stroke='currentColor' stroke-width='6'/>" +
      "<circle cx='100' cy='100' r='66' fill='none' stroke='currentColor' stroke-width='4'/>" +
      beads() +
      "<text x='100' y='113' text-anchor='middle' font-family='Cinzel,Georgia,serif' font-weight='800' font-size='32' letter-spacing='1' fill='currentColor'>B-JMC</text>" +
      "</svg>";
  }

  function medallion() {
    var html = '';
    for (var i = 0; i < LAYERS; i++) html += layer(i);
    return "<span class='bjmc3d-logo' aria-hidden='true'><span class='bjmc3d-stage'><span class='bjmc3d-coin'>" + html + "</span></span></span>";
  }

  function init() {
    var links = document.querySelectorAll('.header__heading-link');
    Array.prototype.forEach.call(links, function (link) {
      if (link.querySelector('.bjmc3d-logo')) return;
      if (!link.querySelector('.h2')) return; // un logo image est déjà défini : on ne touche à rien
      var label = (link.textContent || 'B-JMC').replace(/\u2122/g, '').trim() || 'B-JMC';
      link.innerHTML = "<span class='visually-hidden'>" + label + "</span>" + medallion();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
